import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixed-deposite',
  templateUrl: './fixed-deposite.component.html',
  styleUrls: ['./fixed-deposite.component.css']
})
export class FixedDepositeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/fixed-deposite/fixed-deposite.component.ts